import React, { ReactNode } from "react";

import { Table } from "trunx";

export interface PanelInfoTableProps {
  rows: [ReactNode | string, ReactNode | string | undefined][];
}

const PanelInfoTable = ({ rows }: PanelInfoTableProps) => {
  return (
    <Table bulma="is-fullwidth">
      <tbody>
        {rows.map(([left, right], index) => (
          <tr key={index}>
            <td
              className={right ? "is-narrow" : "has-text-centered"}
              colSpan={right ? 1 : 2}
            >
              {left}
            </td>
            {right && <td>{right}</td>}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default PanelInfoTable;
